import React from 'react';

function parseAttrs(attrs: string, baseKey: string): React.ReactNode[] {
  if (!attrs) return [];
  const nodes: React.ReactNode[] = [];
  const re = /(\s+)([a-zA-Z][a-zA-Z0-9:_.-]*)(\s*=\s*)("(?:[^"]*)")/g;
  let last = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(attrs)) !== null) {
    if (m.index > last) {
      nodes.push(<span key={`${baseKey}-p${last}`}>{attrs.slice(last, m.index)}</span>);
    }
    nodes.push(<span key={`${baseKey}-ws${m.index}`}>{m[1]}</span>);
    nodes.push(<span key={`${baseKey}-an${m.index}`} className="xml-attr">{m[2]}</span>);
    nodes.push(<span key={`${baseKey}-eq${m.index}`} className="xml-punct">{m[3]}</span>);
    nodes.push(<span key={`${baseKey}-av${m.index}`} className="xml-value">{m[4]}</span>);
    last = m.index + m[0].length;
  }
  if (last < attrs.length) {
    nodes.push(<span key={`${baseKey}-r`}>{attrs.slice(last)}</span>);
  }
  return nodes;
}

export default function XmlHighlight({ xml }: { xml: string }) {
  const parts = xml.split(/(<[^>]+>)/);
  return (
    <>
      {parts.map((part, i) => {
        if (!part.startsWith('<')) {
          return <span key={i} className="xml-text">{part}</span>;
        }
        const m = part.match(/^(<\/?)([a-zA-Z][a-zA-Z0-9:_.-]*)([\s\S]*?)(\/?>)$/);
        if (!m) return <span key={i} className="xml-punct">{part}</span>;
        const [, open, name, rest, close] = m;
        return (
          <span key={i}>
            <span className="xml-punct">{open}</span>
            <span className="xml-tag">{name}</span>
            {parseAttrs(rest, String(i))}
            <span className="xml-punct">{close}</span>
          </span>
        );
      })}
    </>
  );
}
